// src/pages/CompleteProfile.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

const CompleteProfile = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const storedEmail = localStorage.getItem("userEmail") || "";

  useEffect(() => {
    const checkIfNameExists = async () => {
      if (!storedEmail) {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${API_BASE}/api/customers/user-profile/${storedEmail}`
        );

        const user = response.data;
        if (user?.name && user?.lastName) {
          navigate("/verify-phone", { replace: true });
          return;
        }
      } catch (err) {
        console.error("❌ Error fetching user profile:", err);
      } finally {
        setLoading(false);
      }
    };

    checkIfNameExists();
  }, [storedEmail, navigate]);

  const handleSubmitName = async () => {
    if (!name.trim() || !lastName.trim()) {
      setMessage("Please enter your full name.");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/customers/update-profile`, {
        email: storedEmail,
        name,
        lastName,
      });

      localStorage.setItem("userName", `${name} ${lastName}`);
      setMessage("Name saved successfully!");
      setTimeout(() => navigate("/verify-phone", { replace: true }), 800);
    } catch (error) {
      console.error("❌ Error saving name:", error);
      setMessage("Server error updating profile.");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-gray-500 text-sm">
        Loading your profile…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">

        {/* Header */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800">
            Complete your profile
          </h2>
          <p className="text-gray-500 mt-1 text-sm">
            Tell us your name to continue
          </p>
        </div>

        {/* Form */}
        <div className="space-y-4">
          <input
            type="text"
            placeholder="First name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <input
            type="text"
            placeholder="Last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <button
            onClick={handleSubmitName}
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Save and continue
          </button>
        </div>

        {message && (
          <p className="text-sm text-red-500 text-center">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default CompleteProfile;

